import { XIcon } from '@heroicons/react/solid';
import { openDB } from 'idb';
import React, { useState,useContext } from 'react'
import Context from '../context/context';
import styles from "../css/SetupForm.module.css";

const DEFAULT_RISTRICTION = {
  running_order_editing: "0",
  running_order_price: "0",
  running_order_edit_item_qty: "0",
  running_order_item_status: "1",
  running_order_delete: "0",
  running_order_add_item: "0",

  complete_order_editing: "0",
  complete_order_price: "0",
  complete_order_edit_item_qty: "0",
  complete_order_item_status: "1",
  complete_order_change_working_day: "0",
  complete_order_delete: "0",
  complete_order_add_item: "0",

  other_menu_and_seat: "0",
  other_menu_open_and_edit: "0",
  other_menu_and_seat_open_menu_and_edit: "0",
  other_menu_and_seat_new_edit_seat_section: "0",
  other_users: "0",

  other_report_Daily_summary: "3",
  other_report_order: "3",
  other_report_customer: "1",
  other_report_item_sale: "3",

  other_quick_access_item_availability: "1",

  other_setup_page_setup: "0",
  other_setup_delivery_setup: "0",
  other_setup_fixed_charges_and_discount: "0",
  other_setup_invoice_setup: "0",
  other_setup_kot_setup: "0",
  other_setup_meal_scheduling: "0",
  other_setup_outlet_details: "0",
  other_setup_payment_mode: "0",
  other_setup_pickup_setup: "0",
  other_setup_role_management: "0",
}
const UserRolePopup = ({ roleInfo, close, setNewRoles, newRoles, setRoles, roles }) => {
  const [roleDetails, setRoleDetails] = useState({ ...roleInfo, restrictions: [{ ...DEFAULT_RISTRICTION, ...roleInfo?.restrictions[0] }] })
  const context = useContext(Context);
  const {
    updateUnSync
  } = context
  console.log("rolesDetails", roleDetails)
  const formSubmits = async () => {
    if (roleInfo.type === "new") {
      setNewRoles(newRoles.map(a => a.role_uuid === roleInfo.role_uuid ? roleDetails : a))

      await handleRoleUnsyncedFile({ ...roleDetails, IDENTIFIER: "role-new:" + roleDetails.role_uuid })
    } else {
      setRoles(roles.map(a => a.role_uuid === roleInfo.role_uuid ? roleDetails : a))
      await handleRoleUnsyncedFile({ ...roleDetails, IDENTIFIER: "role:" + roleDetails.role_uuid })

    }
    let data = Object.keys(roleDetails)
      .filter((key) => key !== "type")
      .reduce((obj, key) => {
        obj[key] = roleDetails[key];
        return obj;
      }, {}
      )
    console.log("role", data)
    await handleRoleLocalDbFile(data)
    close()
  }
  const handleRoleLocalDbFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("role_management", "readwrite").objectStore("role_management");
    await tx.put(
      data
    );

  };
  const handleRoleUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    await tx.put({
      ...data, APPROVED: 1,
      BACKUP: 0
    });
    updateUnSync()
  };
  return (
    <form
      className={styles.form}
      style={{
        position: "absolute",
        right: "0%",
        borderRadius: "20px",
        height: "90vh",
        top: "0px",
        zIndex: "999",
        width: "800px",
        background: "white"
      }}
    >
      <div className={styles.heading}>
        <h1 style={{ width: "90%", textAlign: "center" }}>User Role - {roleInfo?.role_name}</h1>
        <XIcon onClick={close} style={{ width: "20px" }} />
      </div>

      <div className={styles.formContainer} style={{ overflow: "scroll" }}>
        <div className={styles.row}>

        <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    true
                  }
                  
                  />
                <span></span>
              </div> Allowed
            </label>
        <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    false
                  }
                  
                  />
                <span></span>
              </div>Not Allowed
            </label>
            </div>
                  <h2>Orders</h2>
        <div className={styles.formGroup}>
          <h3>Running Orders</h3>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.running_order_editing === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], running_order_editing: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div> Editing
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.running_order_price === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], running_order_price: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Edit Item Price
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.running_order_edit_item_qty === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], running_order_edit_item_qty: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Editing Item Quantity
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.running_order_item_status === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], running_order_item_status: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Cancel / Revert Item Status
            </label></div>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.running_order_delete === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], running_order_delete: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Delete Orders
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.running_order_add_item === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], running_order_add_item: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Add More Items
            </label>
          </div>
        </div>
        <div className={styles.formGroup}>
          <h3>Complete Orders</h3>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.complete_order_editing === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], complete_order_editing: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Editing
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.complete_order_price === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], complete_order_price: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Edit Item Price
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.complete_order_edit_item_qty === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], complete_order_edit_item_qty: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Editing Item Quantity
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.complete_order_item_status === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], complete_order_item_status: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Cancel / Revert Item Status
            </label></div>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.complete_order_change_working_day === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], complete_order_change_working_day: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Change Working Day
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.complete_order_delete === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], complete_order_delete: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Delete Orders
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.complete_order_add_item === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], complete_order_add_item: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Add More Items
            </label>
          </div>
        </div>
        <h2>Others</h2>
        <div className={styles.formGroup}>
          <h3>Master</h3>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_menu_and_seat === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_menu_and_seat: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Menu & Seats
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_menu_and_seat_open_menu_and_edit === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_menu_and_seat_open_menu_and_edit: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Menu & Seats {">"} Open Menu and Edit
            </label>
          </div>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_menu_and_seat_new_edit_seat_section === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_menu_and_seat_new_edit_seat_section: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Menu & Seats {">"} New/Edit : Seat/Section
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_users === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_users: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Users
            </label>
          </div>
        </div>
        <div className={styles.formGroup}>
          <h3>Reports</h3>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>
              Daily Summary:
              <div>
                <input
                  type="number"
                  value={
                    parseInt(roleDetails?.restrictions[0]?.other_report_Daily_summary)
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_report_Daily_summary: e.target.value
                      }]
                    });
                  }}
                  style={{width:"40px",marginLeft:"20px"}}
                />days
              </div>
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>
              Orders:
              <div>
                <input
                  type="number"
                  value={
                    parseInt(roleDetails?.restrictions[0]?.other_report_order)
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_report_order: e.target.value
                      }]
                    });
                  }}
                  style={{ width: "40px", marginLeft: "20px"}}
                />days
              </div>
            </label>
          </div>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_report_customer === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_report_customer: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Customers
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginRight: "10px" }}>
              Item Sales:
              <div>
                <input
                  type="number"
                  value={
                    parseInt(roleDetails?.restrictions[0]?.other_report_item_sale)
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_report_item_sale: e.target.value
                      }]
                    });
                  }}
                  style={{ width: "40px", marginLeft: "20px"}}
                  maxLength={3}
                />days
              </div>
            </label>
          </div>
        </div>
        <div className={styles.formGroup}>
          <h3>Quick Access</h3>

          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "30%", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_quick_access_item_availability === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_quick_access_item_availability: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Item Availability
            </label>

          </div>

        </div>
        <div className={styles.formGroup}>
          <h3>Setup</h3>

          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_page_setup === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_page_setup: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Setup Page
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_delivery_setup === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_delivery_setup: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Delivery Setup
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_fixed_charges_and_discount === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_fixed_charges_and_discount: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Fixed Charge and Discount
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_invoice_setup === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_invoice_setup: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Invoice Setup
            </label></div>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_kot_setup === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_kot_setup: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Kot Setup
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_meal_scheduling === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_meal_scheduling: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Meal Scheduling
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_outlet_details === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_outlet_details: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Outlet Details
            </label>
          </div>
          <div className={styles.row}>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_payment_mode === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_payment_mode: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Payment Modes</label>

            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_pickup_setup === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_pickup_setup: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Pickup Setup
            </label>
            <label style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "10px" }}>

              <div>
                <input
                  type="checkbox"
                  checked={
                    roleDetails?.restrictions[0]?.other_setup_role_management === "1"
                  }
                  onChange={(e) => {
                    setRoleDetails({
                      ...roleDetails, restrictions: [{
                        ...roleDetails.restrictions[0], other_setup_role_management: e.target.checked
                          ? "1"
                          : "0"
                      }]
                    });
                  }}
                />
                <span></span>
              </div>Role Management
            </label>

          </div>
        </div>
        <button type='button' onClick={formSubmits} className={styles.submit}>Save changes</button>
      </div>
    </form>
  )
}

export default UserRolePopup